import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					title={"Hearth House"}
					image={require('./video.jpg')}
					bg="#f04e35"
					// video={{ mp4: require('./video.mp4')}}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">Establishing a solid digital foundation.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/hearth-house.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi provides a wide range of digital marketing services together with an advanced website design.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Marketing Strategy</li>
									<li>Digital Marketing Management</li>
									<li>Website <a href="https://www.hearthhousebunbury.com.au/" target="_blank">hearthhousebunbury.com.au</a></li>
									<li>Advanced search capability</li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Animated elements for smooth flow</li>
									<li>Graphic Design</li>
									<li>Email Newsletter Design</li>
									<li>Video Production</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Hearth House Bunbury" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Hearth House Bunbury" width="100%" />
								<img src={require('./example-2.jpg')} alt="Hearth House Bunbury" width="100%" />
								<img src={require('./example-3.jpg')} alt="Hearth House Bunbury" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/HearthHouse/index.js